interface iTokenNameMap {
  [map: string]: string;
}

const TOKEN_NAMES: iTokenNameMap = {
  '0x': '0x',
  '0xBitcoin': '0xBitcoin',
  '1inch': '1inch Network',
  '2GIVE': '2Give',
  AAVE: 'AAVE',
  ACT: 'Achain',
  ACC: 'Action Coin',
  ADD: 'ADD Token',
  ADX: 'AdEx',
  ELF: 'aelf',
  AEON: 'Aeon',
  ARNX: 'Aeron-1',
  ARN: 'Aeron',
  AE: 'Aeternity',
  AGRS: 'Agoras Tauchain',
  DLT: 'Agrello',
  AION: 'Aion',
  AST: 'AirSwap',
  ALGO: 'Algorand',
  SOC: 'All Sports',
  AMB: 'Ambrosus',
  AMPL: 'Ampleforth',
  ANKR: 'Ankr Network',
  APE: 'ApeCoin',
  APPC: 'AppCoins',
  ANT: 'Aragon',
  ARB: 'Arbitrum',
  ABT: 'Arcblock',
  ARDR: 'Ardor',
  ARG: 'Argentum',
  ARK: 'Ark',
  XAS: 'Asch',
  ATM: 'ATMChain',
  AUD: 'AUDRamp',
  AET: 'Augmint Euro Token',
  REP: 'Augur',
  AURY: 'Aurory',
  NIOX: 'Autonio',
  AVAX: 'Avalanche',
  AYWA: 'Aywa',
  BAL: 'Balancer',
  BANANA: 'BananaCoin',
  BNT: 'Bancor Network Token',
  BAND: 'Band Protocol',
  BAT: 'Basic Attention Token',
  BCBC: 'BCBC',
  BCC: 'BCC',
  BEAM: 'Beam',
  BELA: 'Belacoin',
  BIX: 'Bibox Token',
  BNB: 'Binance Coin',
  BAY: 'BitBay',
  BTDX: 'Bitcloud',
  BCHABC: 'Bitcoin Cash ABC',
  BCH: 'Bitcoin Cash',
  BCD: 'Bitcoin Diamond',
  BTG: 'Bitcoin Gold',
  BTCH: 'Bitcoin Hush',
  XBC: 'Bitcoin Plus',
  BTCP: 'Bitcoin Private',
  BTC: 'Bitcoin',
  BTCD: 'BitcoinDark',
  BSV: 'BitcoinSV',
  BTCZ: 'BitcoinZ',
  BTX: 'Bitcore',
  BDL: 'Bitdeal',
  BQ: 'bitqy',
  BSD: 'BitSend',
  BTS: 'BitShares',
  BTT: 'BitTorrent',
  BLK: 'BlackCoin',
  BLZ: 'Blazecoin',
  BLCN: 'BLCN',
  XBP: 'BlitzPredict',
  ARRR: 'Block Array',
  BCIO: 'Blockchain.io',
  BCPT: 'BlockMason Credit Protocol',
  BLOCK: 'Blocknet',
  BPT: 'Blockport',
  TIX: 'Blocktix',
  CDT: 'Blox',
  FIDA: 'Bonfida',
  BOOTY: 'Booty',
  BOS: 'BOScoin',
  BNTY: 'Bounty0x',
  BRD: 'Bread',
  BURST: 'Burst',
  BCN: 'Bytecoin',
  BTM: 'Bytom',
  BZE: 'BZEdge',
  CND: 'Canada eCoin',
  CALL: 'Capital',
  ADA: 'Cardano',
  CTR: 'Centra',
  LINK: 'ChainLink',
  CM: 'Chainmakers',
  CHAINZILLA: 'Chainzilla',
  CHAT: 'ChatCoin',
  CHZ: 'Chiliz',
  CHIPS: 'CHIPS',
  CVC: 'Civic',
  CLAM: 'Clams',
  CLOAK: 'Cloakcoin',
  CNY: 'CNY',
  COB: 'Cobinhood',
  COLX: 'ColossusXT',
  CMT: 'Comet',
  CMM: 'Commercium',
  COMP: 'Compound',
  COQ: 'COQUI Cash',
  CTXC: 'Cortex',
  ATOM: 'Cosmos',
  XCP: 'Counterparty',
  CS: 'CREDITS',
  CRW: 'Crown',
  CRPT: 'Crypterium',
  MCO: 'Crypto.com',
  CRNX: 'Cryptonex',
  QBT: 'Cubits',
  CRV: 'Curve DAO Token',
  DAI: 'Dai',
  DASH: 'Dash',
  DTA: 'DATA',
  DAT: 'Datum',
  MANA: 'Decentraland',
  DCR: 'Decred',
  DBC: 'DeepBrain Chain',
  DNUT: 'DeezNuts',
  DNR: 'Denarius',
  DENT: 'Dent',
  DCN: 'Dentacoin',
  DTH: 'Dether',
  DEW: 'DEW',
  DGB: 'DigiByte',
  XDN: 'DigitalNote',
  DGD: 'DigixDAO',
  DNT: 'district0x',
  DOCK: 'Dock',
  DOGE: 'Doge',
  DRGN: 'Dragonchain',
  GOLD: 'Dragonereum Gold',
  DROP: 'Dropil',
  DTR: 'Dynamic Trading Rights',
  EBST: 'eBoost',
  EDG: 'Edgeless',
  EDO: 'Eidoo',
  EMC2: 'Einsteinium',
  ELA: 'Elastos',
  ECA: 'Electra',
  ELEC: 'Electrify.Asia',
  ETN: 'Electroneum',
  ELIX: 'Elixir',
  ELLA: 'Ellaism',
  EMB: 'Emblem',
  EMC: 'EmerCoin',
  ENG: 'Enigma',
  ENJ: 'Enjin Coin',
  EOS: 'EOS',
  EOP: 'EOP',
  EQUA: 'EQUA',
  EQ: 'Equaliser',
  CLOWN: 'Ether Clown',
  DOGETH: 'EtherDoge',
  ETC: 'Ethereum Classic',
  ETH: 'Ethereum',
  FUEL: 'Etherparty',
  LEND: 'ETHLend',
  ETHOS: 'Ethos',
  EUR: 'EUR',
  EVX: 'Everex',
  IQ: 'Everipedia',
  XUC: 'Exchange Union',
  EXMO: 'EXMO',
  EXP: 'Expanse',
  FCT: 'Factom',
  FAIR: 'Faircoin',
  FTC: 'Feathercoin',
  FIL: 'Filecoin [IOU]',
  FLO: 'FLO',
  FLUX: 'Flux',
  FLDC: 'Foldingcoin',
  FUJI: 'Fujicoin',
  FUN: 'FunFair',
  FSN: 'FUSION',
  GAME: 'GameCredits',
  GAS: 'Gas',
  GBP: 'GBP',
  GUSD: 'Gemini dollar',
  GENERIC: 'GENERIC',
  GVT: 'Genesis Vision',
  GTO: 'Gifto',
  GMR: 'Gimmer',
  GIN: 'GINcoin',
  GZR: 'Gizer',
  GSC: 'Global Social Chain',
  GBX: 'Globitex',
  GLX: 'GLX Equity Token',
  GNO: 'Gnosis',
  GNT: 'Golem',
  GRC: 'Gridcoin',
  GRIN: 'Grin',
  GRS: 'Groestlcoin',
  NLG: 'Gulden',
  GUP: 'Guppy',
  GXS: 'GXChain',
  HNS: 'Handshake',
  ONE: 'Harmony',
  HBIT: 'HashBit Blockchain',
  HPB: 'High Performance Blockchain',
  HIG: 'Highcoin',
  HODL: 'HOdlcoin',
  HOT: 'Holo',
  ZEN: 'Horizen',
  HOTT: 'HOTTO',
  HSR: 'HShare',
  HTML: 'HTMLCOIN',
  HUC: 'Huntercoin',
  HUSD: 'HUSD',
  HUSH: 'Hush',
  ENTRP: 'Hut34 Entropy',
  AMP: 'HyperSpace (Synereo)',
  ICX: 'ICON',
  ICN: 'Iconomi',
  RLC: 'iExec RLC',
  IGNIS: 'Ignis',
  XIN: 'Infinity Economics',
  INJ: 'Injective',
  INK: 'Ink',
  ILK: 'Inlock Token',
  INS: 'Insolar',
  ICP: 'Internet Computer',
  IOP: 'Internet of People',
  ION: 'ION',
  IOST: 'IOStoken',
  ITC: 'IoT Chain',
  MIOTA: 'IOTA',
  IOTX: 'IoTeX',
  JNT: 'Jibrel Network',
  JPY: 'JPY',
  KRB: 'Karbo',
  KIN: 'Kin',
  KMD: 'Komodo',
  KCS: 'KuCoin Shares',
  KSM: 'Kusama',
  KNC: 'Kyber Network',
  TAU: 'Lamden',
  LBC: 'LBRY Credits',
  LSK: 'Lisk',
  LTC: 'Litecoin',
  LPT: 'Livepeer Token',
  LOOM: 'Loom Network',
  LRC: 'Loopring',
  LUN: 'Lunyr',
  LKK: 'Lykke',
  XMG: 'Magi',
  MAID: 'MaidSafeCoin',
  MFT: 'Mainframe',
  MKR: 'Maker',
  MSR: 'Masari',
  MATIC: 'Matic',
  MAX: 'MAX Token',
  MZC: 'MAZA',
  MCAP: 'MCAP',
  MEDX: 'Medibloc',
  MDS: 'MediShares',
  MEET: 'MEET.ONE',
  MLN: 'Melon',
  MTL: 'Metal',
  ETP: 'Metaverse ETP',
  MINEX: 'MinexCoin',
  MITH: 'Mithril',
  MNZ: 'MNZ',
  MOAC: 'MOAC',
  MOD: 'Modum',
  MDA: 'Moeda Loyalty Points',
  MONA: 'MonaCoin',
  XMO: 'Monero Original',
  XMR: 'Monero',
  MTH: 'Monetha',
  XMCC: 'Monoeci',
  MUSIC: 'Musicoin',
  XMY: 'Myriad',
  NGC: 'NAGA',
  NMC: 'Namecoin',
  NANO: 'Nano',
  NAV: 'NavCoin',
  NDZ: 'NDZ',
  NEBL: 'Neblio',
  NAS: 'Nebulas',
  XEM: 'NEM',
  NEO: 'NEO',
  NEOS: 'Neoscoin',
  NEU: 'Neumark',
  NEXO: 'Nexo',
  NXS: 'Nexus',
  NKN: 'NKN',
  NLC2: 'NoLimitCoin',
  NOTE: 'Note Blockchain',
  NCASH: 'Nucleus Vision',
  NULS: 'Nuls',
  NMR: 'Numeraire',
  NXT: 'NXT',
  GBYTE: 'Obyte',
  OK: 'OKCash',
  OMG: 'OMG Network',
  OMNI: 'Omni',
  ONT: 'Ontology',
  OAX: 'OpenANX',
  OP: 'Optimism',
  OXT: 'Orchid',
  ORDI: 'ORDI',
  OST: 'OST',
  OXF: 'OX Fina',
  OXY: 'Oxygen',
  OYS: 'Oyster',
  PAC: 'PACcoin',
  PART: 'Particl',
  PASL: 'Pascal Lite',
  PASC: 'Pascalcoin',
  PAXG: 'PAX Gold',
  PAX: 'PAX Token',
  PAYX: 'Paypex',
  PPP: 'PayPie',
  PPC: 'Peercoin',
  PLR: 'Pillar',
  PINK: 'Pinkcoin',
  PIRL: 'Pirl',
  PIVX: 'PIVX',
  POE: 'Po.et',
  POA: 'POA Network',
  POLIS: 'Polis',
  DOT: 'Polkadot',
  POLY: 'Polymath Network',
  PPT: 'Populous',
  POT: 'Potcoin',
  POWR: 'Power Ledger',
  PRE: 'Presearch',
  XPM: 'Primecoin',
  XPR: 'Proton',
  NPXS: 'Pundi X',
  PUNGO: 'Pungo Token',
  PURA: 'Pura',
  QASH: 'QASH',
  QIWI: 'QIWI',
  QLC: 'QLC Chain',
  QTUM: 'Qtum',
  QNT: 'Quant',
  QSP: 'Quantstamp',
  QRL: 'Quantum Resistant Ledger',
  RADS: 'Radium',
  RDN: 'Raiden Network Token',
  RAP: 'Rapture',
  RVN: 'Ravencoin',
  RAY: 'Raydium',
  RHOC: 'RChain',
  RCN: 'Rcoin',
  RDD: 'Reddcoin',
  REN: 'Ren',
  REQ: 'Request',
  R: 'Revain',
  RIC: 'Riecoin',
  RISE: 'Rise',
  RPX: 'RPX',
  RUB: 'RUB',
  RYO: 'Ryo Currency',
  SAFE: 'Safe',
  SAFEMOON: 'SafeMoon',
  SALT: 'SALT',
  SLS: 'SaluS',
  SAN: 'Santiment Network Token',
  SBER: 'SBERBANK',
  SRM: 'Serum',
  SHIFT: 'Shift',
  SC: 'Siacoin',
  SIB: 'SIBCoin',
  SDAI: 'Single Collateral DAI',
  SNGLS: 'SingularDTV',
  AGI: 'SingularityNET',
  SIN: 'SINOVATE',
  SRN: 'Sirin Labs Token',
  SKL: 'SKALE Network',
  SKY: 'Skycoin',
  SMART: 'SmartCash',
  SNG: 'SnowGem',
  SOL: 'Solana',
  SLR: 'Solarcoin',
  SOME: 'SoMee.Social',
  SONM: 'SONM',
  SPHTX: 'SophiaTX',
  SPANK: 'SpankChain',
  STX: 'Stacks',
  ATLAS: 'Star Atlas',
  START: 'Startcoin',
  SBD: 'Steem Dollars',
  STEEM: 'Steem',
  XLM: 'Stellar',
  GMT: 'STEPN',
  STQ: 'Storiqa',
  STORJ: 'Storj',
  STORM: 'Storm',
  STAK: 'STRAKS',
  STRAX: 'Stratis',
  DATA: 'Streamr DATAcoin',
  SUB: 'Substratum',
  SUI: 'SUI',
  SUMO: 'Sumokoin',
  UNITY: 'SuperNET',
  SUSHI: 'SushiSwap',
  CHSB: 'SwissBorg',
  SNX: 'Synthetix',
  SYS: 'Syscoin',
  TAAS: 'TaaS',
  TAEL: 'Tael',
  TEL: 'Telcoin',
  PAY: 'TenX',
  TERN: 'Ternio',
  USDT: 'Tether',
  XTZ: 'Tezos',
  GRT: 'The Graph',
  SAND: 'The Sandbox',
  THETA: 'Theta Network',
  TNT: 'Tierion',
  TNB: 'Time New Bank',
  TBX: 'Tokenbox',
  TKN: 'TokenCard',
  TEN: 'Tokenomy',
  TPAY: 'TokenPay',
  TKS: 'Tokes Platform',
  TOMO: 'TomoChain',
  TZC: 'TrezarCoin',
  TRIG: 'Triggers',
  TNC: 'Trinity Network Credit',
  TRX: 'TRON',
  TGC: 'TrueGalaxyCash',
  TUSD: 'TrueUSD',
  TRTL: 'TurtleCoin',
  UBQ: 'Ubiq',
  UMA: 'UMA',
  UNI: 'Uniswap',
  LEO: 'Unus Sed LEO',
  USDC: 'USD Coin',
  USD: 'USD',
  OOT: 'Utrum',
  UTK: 'UTRUST',
  XVC: 'Vcash',
  VET: 'VeChain',
  XVG: 'Verge',
  VTC: 'Vertcoin',
  VRSC: 'VerusCoin',
  VTHO: 'VeThor Token',
  VIA: 'Viacoin',
  VIBE: 'VIBE',
  VIB: 'Viberate',
  VIVO: 'VIVO',
  WGR: 'Wagerr',
  WTC: 'Waltonchain',
  WAN: 'Wanchain',
  WAVES: 'Waves',
  WAXP: 'WAX',
  WICC: 'WaykiChain',
  WPR: 'WePower',
  WINGS: 'Wings',
  WDC: 'Worldcoin',
  WBTC: 'Wrapped Bitcoin',
  XP: 'XP',
  XPA: 'XPA',
  XRP: 'XRP',
  XBY: 'XtraBYtes',
  YFI: 'yearn.finance',
  YOYOW: 'YOYOW',
  ZEC: 'Zcash',
  ZCL: 'Zclassic',
  XZC: 'Zcoin',
  ZEL: 'ZelCash',
  ZEST: 'Zest',
  ZIL: 'Zilliqa',
};

export default TOKEN_NAMES;
